// extracted by mini-css-extract-plugin
module.exports = {"container":"FlavorSelector_container__6wmGg","slide-in-out":"FlavorSelector_slide-in-out__cHCip","fade-in-out":"FlavorSelector_fade-in-out__unE6B"};